export const SET_PAYSIMPLE_CHECKOUT_TOKEN =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_CHECKOUT_TOKEN';
export type SET_PAYSIMPLE_CHECKOUT_TOKEN = typeof SET_PAYSIMPLE_CHECKOUT_TOKEN;

export const SET_PAYSIMPLE_CHECKOUT_EXPIRATION =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_CHECKOUT_EXPIRATION';
export type SET_PAYSIMPLE_CHECKOUT_EXPIRATION = typeof SET_PAYSIMPLE_CHECKOUT_EXPIRATION;

export const SET_PAYSIMPLE_CHECKOUT_URL =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_CHECKOUT_URL';
export type SET_PAYSIMPLE_CHECKOUT_URL = typeof SET_PAYSIMPLE_CHECKOUT_URL;

export const SET_PAYSIMPLE_CHECKOUT_IS_PENDING =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_CHECKOUT_IS_PENDING';
export type SET_PAYSIMPLE_CHECKOUT_IS_PENDING = typeof SET_PAYSIMPLE_CHECKOUT_IS_PENDING;

export const SET_PAYSIMPLE_CHECKOUT_ERROR =
  'rpb2b-react/paysimple/SET_PAYSIMPLE_CHECKOUT_ERROR';
export type SET_PAYSIMPLE_CHECKOUT_ERROR = typeof SET_PAYSIMPLE_CHECKOUT_ERROR;

export default {
  SET_PAYSIMPLE_CHECKOUT_TOKEN,
  SET_PAYSIMPLE_CHECKOUT_EXPIRATION,
  SET_PAYSIMPLE_CHECKOUT_URL,
  SET_PAYSIMPLE_CHECKOUT_IS_PENDING,
  SET_PAYSIMPLE_CHECKOUT_ERROR
};
